import { io } from "socket.io-client";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

export const socket = io(API_URL, {
  withCredentials: true,
  autoConnect: false,
});

// Socket connection
export const connectSocket = () => socket.connect();
export const disconnectSocket = () => socket.disconnect();
// Room events
export const joinRoom = (roomId) => {
  socket.emit("join-room", { roomId });

};

export const onJoinedRoom = (cb) => socket.on("joined-room", cb);
export const offJoinedRoom = () => socket.off("joined-room");
// Chat events
export const sendMsg = (data) => socket.emit("msg", data);
export const onMessage = (cb) => socket.on("msg-recieved", cb);
export const offMessage = () => socket.off("msg-recieved");
export const onUserJoined = (cb) => socket.on("user-joined", cb);
export const offUserJoined = () => socket.off("user-joined");

// WebRTC signalling events
export const sendOffer = (data) => socket.emit("webrtc-offer", data);
export const sendAnswer = (data) => socket.emit("webrtc-answer", data);
export const sendIceCandidate = (data) => socket.emit("ice-candidate", data);

export const onOffer = (cb) => socket.on("webrtc-offer", cb);
export const onAnswer = (cb) => socket.on("webrtc-answer", cb);
export const onIceCandidate = (cb) => socket.on("ice-candidate", cb);

export const offOffer = () => socket.off("webrtc-offer");
export const offAnswer = () => socket.off("webrtc-answer");
export const offIceCandidate = () => socket.off("ice-candidate");

// code socket
 
export const CodeEditorOn = (roomId)=>{
  socket.emit("code-begin", roomId)
}
export const saveCode = (data) =>{
  // console.log(data)
  socket.emit("save-code", data);
}

export const emitChangeCode = (data)=>{
  socket.emit('code-change', data);
}
export const onCodeChange = (codeSnapshot) =>{
  socket.on('code-changed',codeSnapshot);
}

// Editor control events
export const setEditorControl = (data) => {
  socket.emit('set-editor-control', data);
}
export const onEditorControlChange = (cb) => {
  socket.on('editor-control-changed', cb);
}
export const offEditorControlChange = () => {
  socket.off('editor-control-changed');
}

// Interview end events
export const endInterview = (data) => {
  socket.emit('end-interview', data);
}
export const onInterviewEnded = (cb) => {
  socket.on('interview-ended', cb);
}
export const offInterviewEnded = () => {
  socket.off('interview-ended');
}
